import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DbSchema } from '../../../../definitions/database';
import { SchemasService } from '../../services/schemas.service';

export const schemaResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<DbSchema> => {
	const schemasSvc = inject(SchemasService);
	const schemaId = route.paramMap.get('schemaId');

	return schemaId
		? schemasSvc.find(parseInt(schemaId)).pipe(catchError(() => of(null)))
		: of(null);
};
